import React from "react";
import Figure4 from "../../Results/EC20Results/Figure4";
import Figure16 from "../../Results/EC20Results/Figure16";
import Figure5 from "../../Results/EC20Results/Figure5";
import Figure6 from "../../Results/EC20Results/Figure6";
import Figure21 from "../../Results/EC20Results/Figure21";
import Figure7 from "../../Results/EC20Results/Figure7";
import Figure22 from "../../Results/EC20Results/Figure22";
import Figure23 from "../../Results/EC20Results/Figure23";
import Figure24 from "../../Results/EC20Results/Figure24";
import Figure8 from "../../Results/EC20Results/Figure8";
import Figure25 from "../../Results/EC20Results/Figure25";
import Figure26 from "../../Results/EC20Results/Figure26";
import Figure27 from "../../Results/EC20Results/Figure27";
import Figure9 from "../../Results/EC20Results/Figure9";
import Figure10 from "../../Results/EC20Results/Figure10";
import Figure11 from "../../Results/EC20Results/Figure11";

import Figure10S from "../../Results/SpaCResults/Figure10";
import Figure11S from "../../Results/SpaCResults/Figure11";


const Article = () => {
  return (
    <div>
      <div className="mb-20">
        <p>
          The final probiotic would contain two plasmids for the respective
          expression of the EC20 gene and SpaC gene. In order to developp it, we
          tested those two parts individually and then together.{" "}
        </p>
        <p className="mb-2">
          Moreover, the desired probiotic has been engineered to prevent
          horizontal gene transfer. Thus, the notebook has been devided in four
          sections :
          </p>
          <ul className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
            <li> EC20 experiments </li>
            <li> SpaC experiments </li>
            <li> Horizontal Gene Transfer prevention experiments </li>
          </ul>
      
        <br></br>
        <h2 id="Intro-EC20_e"> EC20 </h2>
        <br></br>
        <table>
          <tbody>
            <tr>
              <td>Plasmid</td>
              <td>pET-3a</td>
            </tr>
            <tr>
              <td>Resistance</td>
              <td>Ampicillin</td>
            </tr>
            <tr>
              <td>Tag</td>
              <td>His</td>
            </tr>
            <tr>
              <td>Expression system</td>
              <td>Constitutively expressed</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <h2 id="Transformation-EC20_e"> Transformation of EC20 plasmid</h2>
        <div className="date">01/08/2023</div>
        <p>
          <u>Aim:</u> Incorporation of the EC20 plasmid in DH5α and BL21
          competent strains. The DH5α transformed bacteria will be used to
          amplify the plasmid and the BL21 transformed bacteria to produce the
          EC20 protein.
        </p>
        <u>Protocols:</u> Bacterial Transformation
        <p>
          <u>Results:</u> After the plasmid dry resuspension of 4µg in 40µL of
          nuclease free water, a concentration of 216ng/µl was measured using a
          Nanodrop.²
        </p>
        <p>
          {" "}
          Three transformations were performed, two of them failed due to the
          cell not being competent and due to the ampicilline being degraded in
          the plates used in this transformation.{" "}
        </p>
        <br></br>

        <br></br>
        <h2 id="PrimaryCulture-EC20_e"> Primary Culture of transformed bacteria with EC20 plasmid
        </h2>
        <div className="date">03/07/2023</div>
          {" "}
        <p>
          <u>Aim:</u> Growing of the DH5α and BL21 transformed bacteria
        </p>
        <u>Protocols:</u> Primary culture
        <p>
          <u>Results:</u> The bacteria did not grow
        </p>
        <br></br>

        <br></br>
        <h2 id="Ampplate-test_e"> Testing the amplicilline plates</h2>
        <div className="date">07/08/2023</div>
        <p>
          <u>Aim:</u> Checking the efficacy of the ampicilline plates
        </p>
        <u>Protocols:</u> Putting non-resistant bacteria on the plate
        <p>
          <u>Results:</u> Bacteria grew on the plate: the ampicilline is
          degraded and the plate are unusable
        </p>
        <br></br>

        <br></br>
        <h2 id="Glycerol-stock-EC20_e">
          {" "}
          Glycerol stock of DH5α and BL21 cells with EC20
        </h2>
        <div className="date">08/08/2023 & 10/08/23</div>
        <p>
          <u>Aim:</u> Storing the transformed bacteria
        </p>
        <u>Protocols:</u> Glycerol stock
        <br></br>

        <br></br>
        <h2 id="Miniprep-EC20_e"> Miniprep of DH5α cells with EC20</h2>
        <div className="date">08/08/2023 & 10/08/2023</div>
        <p>
          <u>Aim:</u> Collecting the EC20 plasmids from the transformed DH5α
          bacteria
        </p>
        <u>Protocols:</u> Miniprep
        <br></br>

        <br></br>
        <h2 id="Proteinase-K-EC20_e"> Western Blot with and without Proteinase K </h2>
        <div className="date">09/08/2023: <mark className="date-text">Primary Culture</mark></div> 
        <div className="date">10/08/2023: <mark className="date-text">Incubation with Proteinase K</mark></div>
        <div className="date">10/08/2023: <mark className="date-text">Boiling</mark></div>
        <div className="date">10/08/2023: <mark className="date-text">Western Blot</mark></div>
        <p>
          <u>Aim: </u> Measure the expression of EC20 protein
        </p>
        <u>Protocols: </u> Primary Culture, Proteinase K, Western Blot
        <p>
          <u>Results:</u> No antibody staining observed
        </p>
        <figure>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/ec20-protk-western.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 1:</u> Western Blot of EC20 with and without Proteinase K, no distictive band observed</p>  
        </figure>
        
        <br></br>

        <br></br>
        <h2 id="Proteinase-K-GFP_e"> Testing of Proteinase K on GFP </h2>
        <div className="date">14/08/2023 </div> 
        <p>
          <u>Aim: </u> Measure the expression of EC20 protein
        </p>
        <u>Protocols: </u> Proteinase K
        <p>
          <u>Results:</u> 
        </p>
        <Figure10S/>
        <p><u>Table 1:</u> Different concentrations of GFP were incubated with PK at various temperatures. The first value 
          represents the initial signal, while the value following the arrow represents the signal after incubation.</p>
          <br></br>
        <Figure11S/>
        <p><u>Table 6:</u> Percentage Change in Fluorescence (Excitation: 488 nm, Emission: 509 nm) pre- and post-incubation with 
          PK across Diverse GFP Concentrations and Temperatures. Blue denotes signal reduction, while green signifies 
          enhancement.</p>
        <br></br>
        <p>The incubation with Proteinase K only degrades 30% or the surface protein at maximum, which is not enough to measure a difference
        in surface expression between bacteria that were incubated wit PK and some that were not. Moreover, as this degradation is inconsistant,
        going from 0% to 30%, the value of 30% cannot be taken as a degredation constant in PK experiments.</p>
        <br></br>

        <br></br>
        <h2 id="Transformation-His_e"> Transformation of His tag plasmid (His Control)</h2>
        <div className="date">22/08/2023 </div> 
        <p>
          <u>Aim:</u> Incorporation of the His tag plasmid in BL21 competent
          strains.
        </p>
        <u>Protocols:</u> Bacterial Transformation
        <p>
          <u>Results:</u> The final concentration is 438 ng/µL
        </p>
        <br></br>


        <br></br>
        <h2 id="Protein-Extraction_e"> Protein extraction of EC20 and Coomassie blue staining</h2>
        <div className="date">22/08/2023: <mark className="date-text">Primary Culture </mark></div> 
        <div className="date">23/08/2023: <mark className="date-text">Protein extraction </mark></div> 
        <div className="date">24/08/2023: <mark className="date-text">Coomassie blue staining</mark> </div> 
        <p>
          <u>Aim:</u> The aim of the Coomassie Blue staining experiment was to detect EC20 
          without need of an antibody. Using MagneHis purification we can isolate protein that have a His tag. 
          These protein are run on a gel and colored blue. If a protein is overexpressed, there should appear a band.
        </p>
        <u>Protocols:</u> Primary Culture, Protein extraction, Comassie blue staining
        <p>
          <u>Results:</u> The protein concentration was found using the Nanodrop
          to be 0.998 mg/mL at the end of the extraction.
          The comassie staining was not concluant.
          <figure>
          
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/coomassie-blue-1-only-ec20.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 2:</u> Coomassie blue with EC20, no distictive band for over-expressed protein, 
            for the lysate bacteria, there is too much signal to distinguish a band</p>
          
        </figure>
        </p>
        <br></br>

        
        <br></br>
        <h2 id="Protein-Extraction-2_e"> Protein extraction of EC20 and His Control</h2>
        <div className="date">24/08/2023: <mark className="date-text">Primary Culture of EC20 and His Control</mark></div> 
        <div className="date">24/08/2023: <mark className="date-text">Secondary Culture of EC20 and His Control</mark> </div> 
        <div className="date">24/08/2023: <mark className="date-text">Induction of His Control</mark> </div> 
        <div className="date">24/08/2023: <mark className="date-text">Protein extraction of EC20 and His Control</mark> </div> 
        <div className="date">24/08/2023: <mark className="date-text">Coomassie blue staining of EC20 and His Control</mark> </div> 
        <div className="date">24/08/2023: <mark className="date-text">Boiling of EC20 and His Control </mark></div> 
        <div className="date">29/08/2023: <mark className="date-text">Western Blot 1 of EC20 and His Control</mark></div> 
        <div className="date">29/08/2023: <mark className="date-text">Western Blot 2 of EC20 and His Control</mark></div> 
        <p>
          <u>Aim:</u> We add the His control to have an example of the thickness of a band that is overexpressed.

          As there was no distinctive band for the His control, we wanted to check whether our control works.
          Therefore we ran a western with the lysate and the purification.
          This allowed us not only to see whether the control is indeed expressed, but also how much of the control, if any, was purified.
          Simultanously two western were run, with two distinct antibodies to verify their quality of the antibodies.
          The EC20 protein was run beside without any deeper intention, just as an additional try to see whether we get a signal this time.
        </p>
        <u>Protocols:</u> Primary Culture, Secondary Cilture, Protein extraction, Boiling, Western Blot
        <p>
          <u>Results:</u> <p>
        <figure>
          
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/coomassie-blue-western.png"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 3:</u> Western with EC20 and His Control, a band is present for His Control but not for EC20</p> 
          
        </figure>
        <figure>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/coomassie-blue-ponceau-s.png"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 4:</u> Ponceau-S Western with EC20 and His Control, this is the loading control for comparison</p> 
        </figure>
        <figure>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/coomassie-blue-1.png"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 5:</u> Coomassie blue with EC20 and His Control, there is no distictive band for the
             over-expressed protein, for the lysate bacteria, there is too much signal to distinguish a band</p> 
        </figure>
      </p>
        </p>
        <br></br>

        <br></br>
        <h2 id="Urea-DTT-1_e"> Urea DTT experiment 1</h2>
        <div className="date">05/09/2023: <mark className="date-text">Primary Culture of EC20 and His Control</mark></div> 
        <div className="date">07/09/2023: <mark className="date-text">Urea DTT experiment</mark> </div> 
        <div className="date">08 /09/2023: <mark className="date-text">Western Blot 1</mark> </div> 
        <div className="date">12/09/2023: <mark className="date-text">Western Blot 2</mark> </div>
        <div className="date">14/09/2023: <mark className="date-text">Western Blot 3</mark> </div>
        <p>
          <u>Aim:  </u> DTT and Urea are reagents that allow the denaturation of Disulfide bridges. 
          <br></br>
          We hypothesised that the reason for the lack of detection for the EC20 construct is due to 
          the inaccessibility of the His tag. This inaccesibility is likely caused by a Disulfide 
          bridge that persists after conventional SDS boiling.
          We hope that the rougher denaturation will free the His tag and allow detection on a western blot.
        </p>
        <u>Protocols:</u> Primary Culture, Urea DTT experiment, Western Blots
        <p>
          <u>Conditions:</u> The Western were performed with both EC20 and His Control for: URea+DTT, Urea, DTT and just SDS.
        </p>
        <p>
          <u>Results:</u> The Western Blot results are black due to our products being faulty.
        </p>
        <p>
        <figure>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/black-western.png"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "25%",
                height: "auto",
              }}
              alt="Result Figure"
            />
           <p><u>Figure 6:</u> Western Blot, the results of the three Western Blots were black due to faulty products being used</p>
        </figure>
      </p>
        
        <br></br>
        

        <br></br>
        <h2 id="Zinc1_e"> Zinc Experiment 1</h2>
        <div className="date">25/09/2023: <mark className="date-text">Primary Culture of EC20 and SpaC</mark></div> 
        <div className="date">26/09/2023: <mark className="date-text">Zinc experiment</mark> </div> 
        <p>
          <u>Aim:  </u> Test the binding capability of EC20 to Zinc with different conditions.
           (In preparation for our Cadmium binding experiment)
        </p>
        <u>Protocols:</u> Primary Culture, Zinc experiment
        <p>
          <u>Conditions:</u> For both EC20 and uninduced-SpaC, we tested for four ODs (0.1, 0.3, 0.5, 1.0), one concentration of zinc
          (2.5 mg/L) and for two incubation times (15 min and 30 min). 
        </p>
        <p>
          <u>Results:</u> 
        </p>
        <Figure21/>
        <p><u>Table 1:</u> Zinc experiment for a bacterial load of OD=0.1 and an incubation time of 15min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure7/>
        <p><u>Table 2:</u> Zinc experiment for a bacterial load of OD=0.3 and an incubation time of 15min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure22/>
        <p><u>Table 3:</u> Zinc experiment for a bacterial load of OD=0.5 and an incubation time of 15min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure23/>
        <p><u>Table 4:</u> Zinc experiment for a bacterial load of OD=1 and an incubation time of 15min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure24/>
        <p><u>Table 5:</u> Zinc experiment for a bacterial load of OD=0.1 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure8/>
        <p><u>Table 6:</u> Zinc experiment for a bacterial load of OD=0.3 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure25/>
        <p><u>Table 7:</u> Zinc experiment for a bacterial load of OD=0.5 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure26/>
        <p><u>Table 8:</u> Zinc experiment for a bacterial load of OD=1 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>
        <p>Taking into account every results for the zinc experiment, we can come to the conclusion that EC20 takes in more cadmium than SpaC 
          as expected. Moreover, it would seem that the incubation time does not have a big influence on the experiment. However, for both 
          incubation times, an 0D of 0.3 seems to be an optimal OD to perform further experiments.</p>
        <br></br>


        <br></br>
        <h2 id="Zinc2_e"> Zinc Experiment 2 </h2>
        <div className="date">28/09/2023: <mark className="date-text">Primary Culture of EC20 and SpaC</mark></div> 
        <div className="date">29/09/2023: <mark className="date-text">Zinc experiment</mark> </div> 
        <p>
          <u>Aim:  </u> Test the binding capability of EC20 to Zinc with different conditions.
           (In preparation for our Cadmium binding experiment)
        </p>
        <u>Protocols:</u> Primary Culture, Zinc experiment
        <p>
          <u>Conditions:</u> For both EC20 and uninduced-SPaC, we tested two incubation times (5min and 30min) at OD=0.3, for an intial concentration of 2.5mg/L of zinc.
        </p>
        <p>
          <u>Results:</u> 
        </p>
        <Figure27/>
        <p><u>Table 9:</u> Concentration of zinc without adding any additional zinc. </p>
          <br></br>

        <Figure9/>
        <p><u>Table 10:</u> Zinc experiment for a bacterial load of OD=0.3 and an incubation time of 5min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure10/>
        <p><u>Table 11:</u> Zinc experiment for a bacterial load of OD=0.3 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <Figure11/>
        <p><u>Table 12:</u> Zinc experiment for a bacterial load of OD=0.3 and an incubation time of 30min. The initial 
          concentration is 1.25mg/L (2.5 g/L diluted by two due to the addition of reactants for the Zn test). The Zn uptake is calculated by
          substracting the Zn concentration after removal of the blank from the Zn concentration of water after removal of the blank.</p>
          <br></br>

        <p>The bacteria expressing EC20 are taking in on average 33.67mg/L more of zinc than our control (bacteria expressing SpaC). </p>
        <br></br>

        <br></br>
        <h2 id="Cadmium1_e"> Cadmium Experiment 1 </h2>
        <div className="date">01/10/2023: <mark className="date-text">Primary Culture of EC20 and SpaC</mark></div> 
        <div className="date">02/10/2023: <mark className="date-text">Cadmium experiment</mark> </div> 
        <p>
          <u>Aim:  </u> Test the binding capability of EC20 to Cadmium with different conditions.
        </p>
        <u>Protocols:</u> Primary Culture, Cadmium experiment
        <p>
          <u>Conditions:</u> For both EC20 and uninduced-SpaC, we tested for one concentration (0.3 mg/L), 
          at OD=0.3 and for 30 min of incubation.
        </p>
        <p>
          <u>Results:</u> 
        </p>
        <Figure4/>
        <p><u>Table 13:</u> Concentration of cadmium without adding any additional cadmium.</p>
          <br></br>

        <Figure16/>
        <p><u>Table 14:</u> Cadmium experiment for a bacterial load of OD=0.3 and an incubation time of 30min. The initial 
          concentration is 0.18mg/L (0.3 g/L diluted by 1.65 due to the addition of reactants for the Zn test). The Cd uptake is calculated by
          substracting the Cd concentration after removal of the blank from the Cd concentration of water after removal of the blank.</p>
          <br></br>
        
        <p>The bacterial concentration was too high to obtain a usable result and we decided to conduct a second experiemtn with less bacteria.</p>
    
        <br></br>


        <br></br>
        <h2 id="Cadmium2_e"> Cadmium Experiment 2 </h2>
        <div className="date">04/10/2023: <mark className="date-text">Primary Culture of EC20 and SpaC</mark></div> 
        <div className="date">05/10/2023: <mark className="date-text">Cadmium experiment</mark> </div> 
        <p>
          <u>Aim:  </u> Test the binding capability of EC20 to Cadmium with different conditions.
        </p>
        <u>Protocols:</u> Primary Culture, Cadmium experiment
        <p>
          <u>Conditions:</u> For both EC20 and uninduced-SpaC, we tested for two ODs (0.01 and 0.06), at one concentration (0.5 mg/L), 
        and for 30 min of incubation.
        </p>
        <p>
          <u>Results:</u> 
        </p>
        <Figure4/>
        <p><u>Table 15:</u> Concentration of cadmium without adding any additional cadmium.</p>
          <br></br>

        <Figure5/>
        <p><u>Table 16:</u> Cadmium experiment for a bacterial load of OD=0.06 and an incubation time of 30min. The initial 
          concentration is 0.3mg/L (0.5 g/L diluted by 1.65 due to the addition of reactants for the Zn test). The Cd uptake is calculated by
          substracting the Cd concentration after removal of the blank from the Cd concentration of water after removal of the blank.</p>
          <br></br>

        <Figure6/>
        <p><u>Table 16:</u> Cadmium experiment for a bacterial load of OD=0.01 and an incubation time of 30min. The initial 
          concentration is 0.3mg/L (0.5 g/L diluted by 1.65 due to the addition of reactants for the Zn test). The Cd uptake is calculated by
          substracting the Cd concentration after removal of the blank from the Cd concentration of water after removal of the blank.</p>
          <br></br>

          <p>The bacteria expressing EC20 are taking in on average 0.027mg/L more of cadmium than our control (bacteria expressing SpaC). </p>
        <br></br>

        <br></br>


        <br></br>
        <h2 id="Urea-DTT-2_e"> Urea DTT experiment 2</h2>
        <div className="date">04/10/2023: <mark className="date-text">Primary Culture of EC20 </mark></div> 
        <div className="date">05/10/2023: <mark className="date-text">Urea DTT experiment</mark> </div> 
        <div className="date">05/10/2023: <mark className="date-text">Western Blot </mark> </div> 
        <p>
          <u>Aim:  </u> We hypothesise that the reason for the lack of detection for the EC20 construct is due to 
          the inaccessibility of the His tag. This inaccesibility is likely caused by a Disulfide 
          bridge that persists after conventional SDS boiling.
          We hope that the rougher denaturation will free the His tag and allow detection on a western blot.
        </p>
        <u>Protocols:</u> Primary Culture, Urea DTT experiment, Western Blot
        <p>
          <u>Conditions:</u> The Western were performed with for: Urea+DTT, and just DTT, and volumes of 1 mL and 2 mL.
        </p>
        <p>
          <u>Results:</u> 
        </p>
        <figure>
            <img
              src="https://static.igem.wiki/teams/4888/wiki/results/western-urea-dtt.png"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "60%",
                height: "auto",
              }}
              alt="Result Figure"
            />
            <p><u>Figure 7:</u></p>Western Blot, a band can be obsvered at the right place (~25kDa) 
            for every conditions but is better defined when Urea is present. Moreover, for only DTT, 2mL 
            were necessary to obtain a signal when only AmL is necessary for Urea+DTT, but the signal remains
            stronger if 2mL is used.
        </figure>
        <br></br>

      </div>
    </div>
  );
};

export default Article;
